import React, { useState, useEffect, useContext } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import ProgrammingService from './ProgrammingService';
import Select from 'react-select';
import schema from './jsonSchema';
import DOMPurify from 'dompurify';
import AppContext from 'context/Context';
import { getConfig } from '@testing-library/react';
const jsonSchema = schema;

const ProgrammingForm = () => {
  const { identifier } = useParams();
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [formData, setFormData] = useState({
    date: date
  });
  const [data, setData] = useState();
  const [firstTime, setFirstTime] = useState(true);
  const [displayOnScreen, setDisplayOnScreen] = useState(false);
  const [classType, setClassType] = useState('CrossFit');
  const [modalShow, setModalShow] = useState(false);
  const [notFoundMessage, setNotFoundMessage] = useState('');
  const [availableClasses, setAvailableClasses] = useState([]);
  const {
    config: { isDark, isRTL, isFluid },
    setConfig
  } = useContext(AppContext);


  useEffect(() => {

    const profileLogged = JSON.parse(localStorage.getItem('profile'));
    const { accountIdentifier } = profileLogged;
    ProgrammingService.retrieveProgram(accountIdentifier, date, classType)
      .then(data => {
        console.log(data);
        setData(data);
      })
      .catch(error => console.log(error));
     let availableTypes = [];
     ProgrammingService.getTypes().then(types => {
      console.log('Available types:', types);
      types.map(type => {
        availableTypes.push({ label: type, value: type });
      });
      setAvailableClasses(availableTypes);
     }).catch(error => console.log(error)); 
  }, [identifier]);
  const handleRetrieveProgram = (overrides = {}) => {
    console.log(formData['date']);
    const profileLogged = JSON.parse(localStorage.getItem('profile'));
    const { accountIdentifier } = profileLogged;
    const selectedDate = overrides.date ?? date;
    const selectedClassType = overrides.classType ?? classType;
    ProgrammingService.retrieveProgram(
      accountIdentifier,
      selectedDate,
      selectedClassType
    )
      .then(data => {
        setNotFoundMessage('');
        console.log(data);
        setData(data);
      })
      .catch(error => {
        if (error.status === 404) {
          setData(null); // No program found for the selected date and class, set data to null to show empty state
          setNotFoundMessage(
            `No program found for ${selectedClassType} on ${selectedDate}`
          );
        } else {
          console.log(error);
        }
      });
  };

  const handleDisplayOnScreen = () => {
    if (!isDark){
      setConfig('isDark', true);
    }
    
    setConfig('isFluid', !isFluid);
    setDisplayOnScreen(!displayOnScreen);
  };  
  const showValue = attributeName => {
    if (
      attributeName === 'description' ||
      attributeName === 'fullWarmUp' ||
      attributeName === 'strength' ||
      attributeName === 'workout' ||
      attributeName === 'modifications' ||
      attributeName === 'coolDown'
    ) {
      if (data[attributeName] === null || data[attributeName] === undefined || data[attributeName] === '') {
        return '';
      }
      const sanitizedHtml = DOMPurify.sanitize(data[attributeName]);
      return (
        <>
        <Card className="m-2 mb-3 p-3">
          <Card.Header><h4 style={{ textTransform: 'capitalize', color: 'orange', fontSize: displayOnScreen ? '60px' : '30px' }}>{attributeName}</h4></Card.Header>
          <div
            height="500px"
            className="workout-content"
            style={{ padding: '15px' }}
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          />
        </Card>
        </>
      );
    }
    return event[attributeName];
  };
  const validateSelectValues = value => {
    return true;
  };
  const buttonsConf = [
    {
      name: 'Save Programming',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Programming');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Create Programming',
    ' ',
    buttonsConf
  );

  return (
    <>
      {modalShow && (
        <FormModal
          message={'Programming  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      <Card>
        <Card.Header>
          <Button className="btn btn-sm" onClick={handleDisplayOnScreen}>
            Display on Screen
          </Button>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <>
              <Row>
                <Col xs={12} md>
                  <Form.Group
                    className="mb-3"
                    controlId="gym"
                    style={{ maxWidth: '100%' }}
                  >
                    <Form.Label>Class</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      name="class"
                      key="class"
                      options={availableClasses}
                      placeholder="Select..."
                      required={true}
                      isMulti={false}
                      classNames={'form-control-sm'}
                      classNamePrefix="react-select"
                      value={formData['class'] || ''}
                      onChange={value => {
                        setFormData({ ...formData, class: value });
                        setClassType(value.value);
                        handleRetrieveProgram({ classType: value.value });
                      }}
                      className={
                        validateSelectValues(formData['class'])
                          ? 'is-valid'
                          : 'is-invalid'
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {'gym' + ' required'}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md>
                  <Form.Group controlId="date" className="mb-3">
                    <Form.Label>Date</Form.Label>
                    <div
                      className="input-group input-group"
                      style={{ maxWidth: '100%' }}
                    >
                      <Form.Control
                        size="sm"
                        style={{ maxWidth: '100%' }}
                        id="date"
                        name="date"
                        type="date"
                        required={true}
                        value={formData['date']}
                        onChange={value => {
                          //setValidatedCallBack(validateSelectValues(field));
                          setFormData({
                            ...formData,
                            date: value.target.value
                          });
                          setDate(value.target.value);
                          handleRetrieveProgram({ date: value.target.value });
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </>
          ) : (
            <p>Loading...</p>
          )}
        </Card.Header>
        <Card.Body>
          {notFoundMessage && (
            <Alert key="warning" variant="warning">
              {notFoundMessage}
            </Alert>
          )}
          {data && (
            <div
              style={{
                maxWidth: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontSize: displayOnScreen ? '50px' : '20px'
              }}
            >
              {showValue('fullWarmUp')}
              {showValue('strength')}
              {showValue('workout')}
              {showValue('modifications')}
              {showValue('coolDown')}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default ProgrammingForm;
